import styled from 'styled-components';

const Separator = styled.hr`
  width: 5vw;
  margin: 8px;
`;

export default Separator;
